import { getDiscount } from '../../../utils/functions';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { removeItemsFromCart } from '../../../actions/cartAction';

const CartProduct = (props) => {
    const { product, name, image, price, cuttedPrice } = props;
    const theme = useTheme();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const removeFromCartHandler = () => {
        dispatch(removeItemsFromCart(product));
        enqueueSnackbar("Removed from Cart", { variant: "success" });
    };

    return (
        <Paper
            elevation={3}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                p: 2,
                m: 1,
                position: 'relative',
                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: theme.shadows[6],
                },
            }}
        >
            <Link to={`/product/${product}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ width: 144, height: 144 }}>
                    <img
                        draggable="false"
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        src={image}
                        alt={name}
                    />
                </Box>
                <Typography
                    variant="subtitle2"
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        minHeight: '3em',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        mt: 1
                    }}
                >
                    {name}
                </Typography>
            </Link>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="h6">₹{(price || 0).toLocaleString()}</Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ textDecoration: 'line-through' }}
                    >
                        ₹{(cuttedPrice || 0).toLocaleString()}
                    </Typography>
                    <Typography variant="body2" color="success.main">
                        {getDiscount(price || 0, cuttedPrice || 0)}% off
                    </Typography>
                </Box>
            </Box>

            <IconButton
                onClick={removeFromCartHandler}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: theme.palette.error.main,
                }}
            >
                <DeleteIcon />
            </IconButton>
        </Paper>
    );
};

export default CartProduct;
